var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable prefer-promise-reject-errors */
import { nanoid } from 'nanoid';
import { parse } from 'qs';
import axios from 'axios';
// CSRF TOKEN
export var CSRF_COOKIE_NAME = 'csrfToken';
export var CSRF_HEADER_NAME = 'x-csrf-token';
export var createHttp = function (options) {
    if (options === void 0) { options = {}; }
    var baseUri = options.baseUri, getAuthorization = options.getAuthorization, query = options.query, url = options.url;
    var http = axios.create({
        baseURL: baseUri,
        url: url,
        params: query,
        timeout: 32000,
        xsrfCookieName: CSRF_COOKIE_NAME,
        xsrfHeaderName: CSRF_HEADER_NAME,
        withCredentials: true,
    });
    http.defaults.headers.common['Content-Type'] = 'application/json';
    // 请求前做一些操作
    http.interceptors.request.use(function (req) { return __awaiter(void 0, void 0, void 0, function () {
        var query, _a, signature, timestamp, nonce, staffname, tokenKey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // 统一带上请求 ID，全流程追溯
                    req.headers['X-Seq-Id'] = "panshi-fe-".concat(nanoid());
                    // 带上请求触发时间
                    req.headers['X-Request-Start-Time'] = "".concat((new Date()).getTime());
                    query = parse(window.location.search, { ignoreQueryPrefix: true });
                    if (query.access_token) {
                        // 生成默认 params
                        if (!req.params) {
                            req.params = {};
                        }
                        req.params.access_token = query.access_token;
                    }
                    if (!(getAuthorization && typeof getAuthorization === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAuthorization()];
                case 1:
                    _a = _b.sent(), signature = _a.signature, timestamp = _a.timestamp, nonce = _a.nonce, staffname = _a.staffname, tokenKey = _a.tokenKey;
                    req.headers['x-timestamp'] = timestamp;
                    req.headers['x-nonce'] = nonce;
                    req.headers['x-token-key'] = tokenKey;
                    req.headers['x-signature'] = signature;
                    req.headers['staffname'] = staffname;
                    _b.label = 2;
                case 2: return [2 /*return*/, req];
            }
        });
    }); });
    /**
       * 处理响应
       * 1. 针对 code 不为 0，或者 http 状态码大于等于 400，一律算作失败
       * 2. 将响应的错误格式化为 `CommonError`
       */
    http.interceptors.response.use(function (res) {
        var _a, _b;
        // 带上请求结束时间时间
        res.headers['X-Request-End-Time'] = "".concat((new Date()).getTime());
        var code = +((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code);
        var message = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message;
        if (code !== 0) {
            return Promise.reject({
                code: code,
                message: message,
                status: 200,
                rawResponse: res,
                rawError: null,
            });
        }
        return __assign(__assign({}, res.data), { axiosOriginalRes: res });
    }, function (err) {
        var _a = httpErrorHandler(err), status = _a.status, code = _a.code, message = _a.message;
        return Promise.reject({
            code: code,
            message: message,
            status: status,
            rawResponse: null,
            rawError: err,
        });
    });
    return http;
};
export function httpErrorHandler(err, reloadCallback) {
    var _a, _b, _c, _d, _e, _f;
    var status = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
    var statusText = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.statusText;
    var message = ((_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) || (err === null || err === void 0 ? void 0 : err.message) || statusText;
    // 取 code 逻辑：请求 response body 中的 code -> AxiosError.code -> HTTP Status -> -500000（一般是跨域）
    var code = +((_f = (_e = err === null || err === void 0 ? void 0 : err.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.code) || (err === null || err === void 0 ? void 0 : err.code) || status || -500000;
    if (typeof code === 'string') {
        // AxiosError.code 是字符串，有可能是连接或响应超时
        code = -500001;
    }
    if (code === -500000) {
        // 这里给一个默认文案, 避免使用axios的默认文案，比如 Network Error
        message = '网络错误，请稍后重试';
    }
    if (status === 401) {
        var currentTime = (new Date()).getTime();
        var lastReLoginTime = +window.localStorage.getItem('omp-service-login-reload-time'); // 上次刷新页面重新获取登陆态的时间
        //  如果 lastReLoginTime 不存在，或者和当前时间相差超过10秒，先刷新页面，重新获取登陆态
        if (!lastReLoginTime || currentTime - lastReLoginTime > 10000) {
            window.localStorage.setItem('omp-service-login-reload-time', String(currentTime));
            if (typeof reloadCallback === 'function') {
                reloadCallback();
            }
            window.location.reload();
        }
    }
    return {
        status: status,
        statusText: statusText,
        code: code,
        message: message,
    };
}
// 使用下载速度 测当前网速 对比 window.navigator.connection.downlink 更精确
export function testDownloadSpeed() {
    var _a = window.location.host.indexOf('woa') > -1 ? WOA_COS_TEST_URL : TENCENT_COS_TEST_URL, url = _a.url, size = _a.size;
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = "".concat(url, "?_t=").concat(Math.random()); // 加个时间戳以避免浏览器只发起一次请求
        var startTime = new Date().getTime();
        img.onload = function () {
            var fileSize = size; // 单位是 kb
            var endTime = new Date().getTime();
            var costTime = endTime - startTime;
            var speed = (fileSize / (endTime - startTime) * 1000).toFixed(2); // 单位是 kb/s
            resolve({ speed: speed, costTime: costTime });
        };
        img.onerror = reject;
    });
}
var TENCENT_COS_TEST_URL = {
    url: 'https://partners-1251956831.cos.ap-guangzhou.myqcloud.com/apply/202103/8dda14de-2e8a-4a16-afe5-04e06c92fb94_WX20210312-152410.png',
    size: 63,
};
var WOA_COS_TEST_URL = {
    url: 'https://cdn.panshi.qq.com/public/8dda14de-2e8a-4a16-afe5-04e06c92fb94_WX20210312-152410.32b17da7.png',
    size: 63,
};
export var SPEED_MIN = 50; // 50kb/s 下载速度以下算慢 客户端网络有问题 不做测速告警
